/** @module csi/widget/_svg/FormatPainter */
define([
	"csi/_base/underscore",
    "csi/widget/RadioToggleButton",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(_, RadioToggleButton, _Plugin, PluginFactory, util) {

	return PluginFactory.declare([RadioToggleButton, _Plugin], {
        "class": "csi-button-toggle csi-single-toggle",
		materialIcon: "format_paint",
		pluginName: "formatPainter",
		title: "CanvasFormatPainter",

		/**
		 * Enable if there is at least one shape is selected
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			this.set("checked", this.editor.isFormatPainterSelected());
			return this.inherited(arguments) && shapes && shapes.length === 1 && this.isValidShape(shapes[0]) && util.unlockedShapedCount(shapes) === 1;
		},

		/**
		 * Return whether valid shape is selected or not for format painter
		 * @param {Shape} shape
		 */
		isValidShape: function(shape) {
			return shape.type !== util.shapeTypes.GROUP_SHAPE && !shape.isPicture;
		},

		/**
		 * Invoke copy formatting action
		 */
		onClick: function() {
			this.editor.formatPainter();
		}
	});
});
